export const SKU_MAPPING = [
  { keywords: ['car insurance'], value: 'car insurance' },
  { keywords: ['bike insurance'], value: 'bike insurance' },
  { keywords: ['health insurance', 'health insurance india'], value: 'health insurance India' },
  { keywords: ['life insurance'], value: 'Life insurance India' },
  { keywords: ['term insurance', 'term insurance india'], value: 'term insurance India' },
  { keywords: ['travel insurance', 'international travel insurance'], value: 'Travel insurance' },
  { keywords: ['abha', 'abha card'], value: 'ABHA card' },
  { keywords: ['e-challan', 'echallan'], value: 'E-Challan' },
  { keywords: ['visa'], value: 'VISA' },
  { keywords: ['hsrp'], value: 'HSRP' },
  { keywords: ['fastag'], value: 'Fastag' },
  { keywords: ['vehicle info', 'vechile info'], value: 'Vehicle info' },
  { keywords: ['rto'], value: 'RTO' },
  { keywords: ['policy analyzer', 'acko policy analyzer'], value: 'ACKO Policy Analyzer' },
]

export const productOrgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.acko.com/#org',
  url: 'https://www.acko.com/',
  name: 'Acko Insurance',
  legalName: 'Acko Insurance',
  email: 'hello@acko.com',
  telephone: ['+91-1800-266-2256', '+91-1800-210-1992'],
  sameAs: [
    'https://www.facebook.com/ackoindia/',
    'https://www.instagram.com/ackoindia/',
    'https://www.linkedin.com/company/acko/',
    'https://x.com/AckoIndia',
    'https://www.youtube.com/channel/UCn1gqDU9TqbR8u6_10S0RJA',
  ],
  logo: {
    '@type': 'ImageObject',
    url: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg',
  },
  image: 'https://acko-brand.ackoassets.com/brand/vector-svg/gradient/horizontal-reverse.svg',
  address: {
    '@type': 'PostalAddress',
    streetAddress:
      '#36/5, Hustlehub One East, Somasandrapalya, 27th Main Rd, Sector 2, ITI Layout, 1st Sector, HSR Layout',
    addressLocality: 'Bengaluru',
    addressRegion: 'Karnataka',
    postalCode: '560102',
    addressCountry: 'IN',
  },
  founder: {
    '@type': 'Person',
    name: 'Varun Dua',
    sameAs: ['https://x.com/duavarun', 'https://in.linkedin.com/in/thevarundua'],
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+91-1800-266-2256',
      contactType: 'Customer Service - General Insurance',
      areaServed: 'IN',
      availableLanguage: [
        'English',
        'Hindi',
        'Tamil',
        'Telugu',
        'Marathi',
        'Gujarati',
        'Bengali',
        'Kannada',
        'Malayalam',
        'Punjabi',
        'Odia',
      ],
    },
    {
      '@type': 'ContactPoint',
      telephone: '+91-1800-210-1992',
      contactType: 'Customer Service - Life Insurance',
      areaServed: 'IN',
      availableLanguage: [
        'English',
        'Hindi',
        'Tamil',
        'Telugu',
        'Marathi',
        'Gujarati',
        'Bengali',
        'Kannada',
        'Malayalam',
        'Punjabi',
        'Odia',
      ],
    },
  ],
  subOrganization: [
    { '@type': 'Organization', name: 'Acko General Insurance Limited', url: 'https://www.acko.com/gi/' },
    { '@type': 'Organization', name: 'Acko Life Insurance Limited', url: 'https://www.acko.com/life/' },
  ],
}
